import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalVariable } from 'app/main/globals';

@Injectable({
  providedIn: 'root'
})
export class AspMyReturnsService {

  constructor(private http: HttpClient) { }

    getLateRetrns(garageKey: string){
      let paramData = {  
        garageKey: garageKey,
        source: "web" 
    };
        // console.log('Calling API with data:', paramData); // Log the data being sent
  
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` + '/v1/sales-order-return/getAllList', paramData);
  
    }
    createCreditNoteUrl(creditNoteId: string, creditNoteNumber: string) {
        const payload = {
          creditNoteId,
          creditNoteNumber
        };
        return this.http.post<any>(`${GlobalVariable.BASE_API_URL_SPARES}/creditnote/create/creditNoteUrl`, payload);
  }
    getLoadingMsg(){
    let paramData ={
      source: "web" 
    }
    // console.log(paramData);
    console.log('-----get loading msg-----------');  
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` +'/app/getAppData',paramData);
  }
}
